<div class="color-yield-wrapper" [ngClass]="{ 'has-text': text }">
  <div class="small-circle m-0" [ngStyle]="{ background: color }"></div>
  <span *ngIf="text" class="ml-2">{{ text }}</span>
</div>
